import { formDraftKey } from "@/lib/formDraft";
import type { DocSlot } from "./conversionErrors";

export type DraftFiles = Partial<Record<DocSlot, string>>;

export const DRAFT_SENSITIVE_FIELDS = ["ssn", "ownerSsn", "ownerPassportNumber"] as const;

export function onboardingDraftKey(form: "apply" | "verify" | "partner", ref: string | null): string {
  return formDraftKey(form, ref);
}

export function previousFileNote(slot: DocSlot, name: string | undefined): string | null {
  if (!name) return null;
  const lead = `You attached ${name} last time. Photos aren't kept in your saved progress, so please attach it again.`;
  return slot === "driverLicense"
    ? `${lead} The name, date of birth and address below came from it.`
    : `${lead} The bank details below came from it.`;
}

export function formatDraftTime(ts: number, locale?: string): string {
  const d = new Date(ts);
  const time = d.toLocaleTimeString(locale, { hour: "numeric", minute: "2-digit" });
  if (d.toDateString() === new Date().toDateString()) return time;
  return d.toLocaleString(locale, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}
